import React from 'react';
import { Box, Grid } from '@mui/material';
import LayoutView from './layout.view';

const Layout: React.FC = () => {
  return (
    <Box>
      <Grid item xs={12}>
        <LayoutView />
      </Grid>
    </Box>
  );
};

export default Layout;
